import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import { useSelector, shallowEqual } from 'react-redux';

import TabSingleTextWrapper from '../../../../common/tabSingleTextWrapper';

const Approvals = forwardRef(({ permissions: { disableEdit }, data }, ref) => {
  const {
    current: { marketing, id: drugId, ingestedId },
    original: { marketing: originalData },
    ingested: {
      marketing: { data: ingestedData, fieldActions: ingestedActions },
    },
  } = useSelector(state => state.drugs, shallowEqual);
  return (
    <TabSingleTextWrapper
      disableEdit={disableEdit}
      footerData={data}
      data={marketing}
      parentKey="marketing"
      childKey="approvals"
      drugId={drugId}
      ingestedId={ingestedId}
      originalData={originalData}
      ingestedData={ingestedData['approvals']}
      ingestionAction={ingestedActions['approvals']}
      parentIngestionAction={ingestedActions}
      ref={ref}
    />
  );
});

Approvals.propTypes = {
  permissions: PropTypes.object.isRequired,
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    isTab: PropTypes.bool.isRequired,
    tabs: PropTypes.array.isRequired,
  }),
};

Approvals.displayName = 'Approvals';

export default Approvals;
